import React, { useState } from "react";
import Avatar from "@material-ui/core/Avatar";
import Skeleton from "@material-ui/lab/Skeleton";

const subdomainPrefix = process.env.REACT_APP_ENV === "dev" ? "dev" : "";

const ImageLoader = ({
  avatar,
  thumb = false,
  variant = "rounded",
  className,
  imgKey,
  alt,
  skeletonVariant = "rect",
  skeletonClassName
}) => {
  const [loading, setLoading] = useState(true);

  const renderImage = () => {
    if (thumb) {
      let parts = imgKey.split("/");
      let file = parts[parts.length - 1];
      parts[parts.length - 1] = `thumbnail-${file}`;
      imgKey = parts.join("/");
    }

    if (avatar) {
      return (
        <Avatar variant={variant} alt={alt} className={className}>
          {loading && <Skeleton variant={skeletonVariant} className={skeletonClassName} />}
          <img
            className={loading ? "d-none" : ""}
            src={`https://${subdomainPrefix}media.carritofacil.cl/?key=${imgKey}`}
            alt={alt}
            onLoad={() => setLoading(false)}
          />
        </Avatar>
      );
    } else {
      return (
        <div className={className}>
          {loading && <Skeleton variant={skeletonVariant} className={skeletonClassName} />}
          <img
            className={loading ? "d-none" : ""}
            src={`https://${subdomainPrefix}media.carritofacil.cl/?key=${imgKey}`}
            alt={alt}
            onLoad={() => setLoading(false)}
          />
        </div>
      );
    }
  };

  return renderImage();
};

export default ImageLoader;
